module.exports = __webpack_public_path__ + "static/media/numpylogo.bcf7b3c7.png";